var o={name:"rzContainerForIcon",props:{micro:Boolean},computed:{classes:function(){return{"container-for-icon--micro":this.micro}}}};export{o as default};
